import * as React from "react";
import {
  Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import { getItemReport } from "../../api/batches";

interface Props {
  batchId: string;
  itemId: string | null;
  filename: string;
  onClose: () => void;
}

/** Plain-text viewer: reports are markdown, shown verbatim to avoid pulling a
 *  renderer into a dialog that only needs to be readable. */
export function ItemReportDialog({ batchId, itemId, filename, onClose }: Props) {
  const [report, setReport] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!itemId) return;
    setReport(null);
    setError(null);
    getItemReport(batchId, itemId)
      .then(setReport)
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, [batchId, itemId]);

  return (
    <Dialog open={!!itemId} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Report — {filename}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {!error && report === null && <CircularProgress size={20} />}
        {report !== null && (
          <Box
            component="pre"
            data-testid="item-report"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily: "inherit", m: 0 }}
          >
            {report}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
